import { jsx as _jsx } from "react/jsx-runtime";
import clsx from 'clsx';
import { forwardRef } from 'react';
import { Input } from './Input';
import classes from './SearchInput.module.css';
export const SearchInput = forwardRef(({ className, ...props }, ref) => {
    return (_jsx(Input, { id: 'search-input', className: clsx(className, classes['uikit-searchInput']), type: 'search', ...props, ref: ref }));
});
//# sourceMappingURL=SearchInput.js.map